module.exports = __webpack_public_path__ + "static/media/avatar-cartoon.1924d413.png";